import {Module} from 'vuex';
import {state} from './state';
import {actions} from './actions'
import {mutations} from './mutations';
import {DespachoState} from './types';
import {RootState} from '@/store/types';
const namespaced: boolean=true;
export const despachoModule:Module<DespachoState,RootState>={
    namespaced,
    state,
    mutations,
    actions
}